import Vue from 'vue'
import monitor from '@/utils/monitor-scroll.js'

Vue.directive('activate-on-scroll', {
  bind (el, {value}) {
    monitor.register(el, value)
  }
})



// WEBPACK FOOTER //
// ./src/directives/activate-on-scroll.js